import { LOUDNESS_DB } from './loudnessScale';

/** Werkseinstellungen (Fallback ohne Kalibrierung). Laufzeit: getAcousticConfig() aus acousticRuntimeConfig. */
export const ACOUSTIC_FACTORY_DEFAULTS = {
  targetSampleRate: 16_000,
  fftSize: 1024,
  hopSize: 512,
  vadFrameSamples: 512,
  historyLimit: 36,
  rmsSilenceGate: 0.007,
  noiseGateDb: LOUDNESS_DB.silenceDb,
  peakThreshold: 0.58,
  phaseLowThreshold: 0.2,
  phaseHighThreshold: 0.7,
  vadPositiveThreshold: 0.62,
  vadNegativeThreshold: 0.47,
  vadRedemptionMs: 900,
  vadPreSpeechPadMs: 120,
  vadMinSpeechMs: 300,
  yamnetWindowSamples: 15_600,
  yamnetWindowHopSamples: 7_800,
  yamnetInferenceThrottleMs: 900,
  /** Kalibriert an Audio_Kalibrierung/geschrei.wav */
  shoutingLoudnessThreshold: 0.78,
  shoutingCrestFactorMin: 3.5,
  shoutingLoudnessWithCrestMin: 0.48,
  shoutingPeakDensityMin: 0.008,
  /** Kalibriert an Audio_Kalibrierung/gemurmel.wav; leise_klasse.wav bleibt darunter (Lautstärke ~0,25) */
  babbleDiffusenessMin: 0.52,
  /** Referenz leise Klassenarbeit: Audio_Kalibrierung/leise_klasse.wav (Einzelsprecher, Lautstärke unter babbleLoudnessMin) */
  babbleNoiseIntensityMin: 0.26,
  babbleTurnTakingMin: 0.3,
  babbleLoudnessMin: 0.28,
  babbleLoudnessMax: 0.8,
  babblePeakDensityMax: 0.008,
  /** Raumaktivität ohne VAD-Sprachframe (z. B. Gemurmel) */
  roomActivityLoudnessMin: 0.1,
  roomActivityNoiseMin: 0.24,
  yamnetBabbleTriggerMin: 0.28,
  yamnetShoutingTriggerMin: 0.32,
  stateHoldSeconds: 3,
  stateHysteresisMargin: 0.12,
  transitionAmbiguityThreshold: 0.14,
  /** Kurze Sprechpausen: Situation + Raumstatus bleiben stabil (ms) */
  speechContextHoldMs: 2_500,
  /** Gleitender Mittelwert für Lautstärke-Anzeige (Sekunden) */
  displayLevelDbWindowSeconds: 5
} as const;

/** @deprecated Verwende getAcousticConfig() – berücksichtigt empirische Kalibrierung */
export const ACOUSTIC_DEFAULTS = ACOUSTIC_FACTORY_DEFAULTS;

export const WINDOW_SECONDS = {
  short: 1,
  integration: 3,
  situation: 7,
  long: 25
} as const;

export const BAND_CONFIG = [
  { key: 'b1', label: '50-120 Hz', meaning: 'Trittschall, Tische, tiefer Raumlarm', hzMin: 50, hzMax: 120 },
  { key: 'b2', label: '120-250 Hz', meaning: 'Stimmgrundtone', hzMin: 120, hzMax: 250 },
  { key: 'b3', label: '250-500 Hz', meaning: 'Sprachkorper', hzMin: 250, hzMax: 500 },
  { key: 'b4', label: '500-1000 Hz', meaning: 'Zentrale Sprachenergie', hzMin: 500, hzMax: 1000 },
  { key: 'b5', label: '1-2 kHz', meaning: 'Sprachverstandlichkeit', hzMin: 1000, hzMax: 2000 },
  { key: 'b6', label: '2-4 kHz', meaning: 'Konsonanten, Sprachdetails', hzMin: 2000, hzMax: 4000 },
  { key: 'b7', label: '4-8 kHz', meaning: 'Viele Stimmen, Unruhe', hzMin: 4000, hzMax: 8000 },
  { key: 'b8', label: '8-16 kHz', meaning: 'Scharfe Gerausche, Peaks', hzMin: 8000, hzMax: 16_000 }
] as const;

export const SPEECH_BAND_KEYS = new Set(['b3', 'b4', 'b5', 'b6']);
export const HIGH_BAND_KEYS = new Set(['b7', 'b8']);
export const BASS_BAND_KEYS = new Set(['b1', 'b2']);
